// JsFromRoutes CacheKey d8fb97a3931fa56c425ecb5c4e2d9028
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  all: /* #__PURE__ */ definePathHelper('get', '/projects/all'),
  toggle: /* #__PURE__ */ definePathHelper('put', '/projects/:id/toggle'),
  create: /* #__PURE__ */ definePathHelper('post', '/projects'),
  show: /* #__PURE__ */ definePathHelper('get', '/projects/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/projects/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/projects/:id'),
}
